export default __webpack_public_path__ + "static/media/1968.ad3a24e2.png";